var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"safety-stocks-info-btn"},[_c('el-badge',{attrs:{"is-dot":_vm.danger}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getsafetystocks}},[_vm._v(" 安全库存信息 ")])],1),_c('safety-stocks-info-modal',{ref:"info"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }